<template>
    <div class="base-panel">
        <div class="base-panel-head space-between">
            <div>发电量&发电小时</div>
            <div class="dark">
                <a-select class="station-type" v-model="type"  defaultValue="0"   @change="handleChange" :getPopupContainer="
                                  triggerNode => {
                                    return triggerNode.parentNode || document.body;
                                  }
                                ">
                    <a-select-option value="3">当日</a-select-option>
                    <a-select-option value="2">当月</a-select-option>
                    <a-select-option value="1">当年</a-select-option>
                    <a-select-option value="4">累计</a-select-option>
                </a-select>
            </div>
        </div>
        <div class="base-panel-body">
            <basic-echarts ref="totalHour" :height="'100%'"></basic-echarts>
        </div>
    </div>
</template>

<script>
    import BasicEcharts from "@/components/Echarts/BasicEcharts";
    export default {
        name: "totalHour",
        components:{
            BasicEcharts
        },
        data(){
            return {
                groupId: 0,
                type: '1',
                typeList:{
                    "1": '月',
                    "2": '日',
                    "3": '时',
                    "4": '年',
                },
                data:{
                    XTime:[],
                    YElec:[],
                    YElecHour:[]
                },
                unitType: 1 //单位类型 1=KWh  1000=MWh
            }
        },
        mounted() {
            this.groupId = this.$Utils.getUserStorage().groupId;
            this.loadCharts()
        },
        methods:{
            async loadCharts(){
                let result = await this.$http.get(this.$baseURL.generateHourChart({groupId: this.groupId, timeDimension: this.type}))
                if(this.type == 1 || this.type == 4){
                    this.unitType = 1000;
                } else {
                    this.unitType = 1;
                }
                //console.log(result)
                this.data.XTime = [];
                this.data.YElec = [];
                this.data.YElecHour = [];
                result.forEach(item => {
                    this.data.XTime.push(item.timeInterval);
                    this.data.YElec.push(Number((item.elecCap / this.unitType).toFixed(2)));
                    //data.YIncome.push(item.powerStationCumulativeIncome.toFixed(2));
                    this.data.YElecHour.push(Number(item.elecHour.toFixed(2)));
                });
                let option = {
                    tooltip : {
                        trigger: 'axis',
                        formatter: (data) => {
                            let html = '';
                            data.forEach((item, index ) => {
                                if(index === 0){
                                    html += item.axisValueLabel + this.typeList[this.type];
                                }
                                html += '<br>' + item.marker + item.seriesName + ': ' + item.value + (item.componentIndex === 0 ? (this.unitType > 1 ? 'MWh' : 'KWh') : 'h');

                            });
                            //console.log(data)
                            return html;
                        }
                    },
                    legend: {
                        top: '5%',
                        selectedMode:false,
                        data:[{
                            name:"发电量",
                            textStyle:{
                                color:"#FFFFFF"
                            }
                        }/*,{
                        name:"收益",
                        textStyle:{
                            color:"#FFFFFF"
                        }
                    }*/,{
                            name:"发电小时",
                            textStyle:{
                                color:"#FFFFFF"
                            }
                        }]
                    },
                    toolbox: {
                        show : false,
                        feature : {
                            mark : {show: true},
                            dataView : {show: true, readOnly: false},
                            magicType : {show: true, type: ['line', 'bar']},
                            restore : {show: true},
                            saveAsImage : {show: true}
                        }
                    },
                    calculable : false,
                    grid:{
                        left: 50,
                        right: '5%',
                        top: '15%',
                        bottom: '10%'
                    },
                    xAxis : [
                        {
                            type : 'category',
                            data : this.data.XTime,
                            axisLabel : {
                                show:true,
                                textStyle:{
                                    color:"#FFFFFF"
                                }
                            },
                            splitArea: {
                                show: false
                            },
                        }
                    ],
                    yAxis : [
                        {
                            type : 'value',
                            position: 'left',
                            name:(this.unitType > 1 ? 'MWh' : 'KWh'),
                            axisLabel : {
                                show:true,
                                textStyle:{
                                    color:"#FFFFFF"
                                }
                            },
                            splitLine : {
                                show: true,
                                color: ['#ccc'],
                                width: 1,
                                lineStyle: {
                                    type: 'dashed'
                                }
                            },
                            splitArea: {
                               show: false
                            },
                            nameTextStyle:{
                                color:"#FFFFFF"
                            }
                        },
                        {
                            type : 'value',
                            position: 'top',
                            name:"h",
                            axisLabel : {
                                show:true,
                                interval: 'auto',    // {number}
                                /*  formatter: '{value} h'*/
                                textStyle:{
                                    color:"#FFFFFF"
                                }
                            },
                            splitLine : {
                                show: false,
                                color: ['#ccc'],
                                width: 1,
                                type: 'dotted'
                            },
                            splitArea: {
                                show: false
                            },
                            nameTextStyle:{
                                color:"#FFFFFF"
                            }
                        }
                    ],
                    series : [
                        {
                            name:'发电量',
                            type:'bar',
                            barMaxWidth:30,
                            yAxisIndex:0,
                            data: this.data.YElec
                        }/*,
                    {
                        name:'收益',
                        type:'bar',
                        barMaxWidth:30,
                        yAxisIndex:0,
                        data:data.YIncome

                    }*/,
                        {
                            name:'发电小时',
                            type:'line',
                            yAxisIndex:1,
                            data: this.data.YElecHour
                        }
                    ]
                };
                this.$refs.totalHour.refresh(option);
            },
            handleChange(){
                this.loadCharts();
            }

        }
    }
</script>

<style scoped>

</style>
